import { BreadCrumbsBar } from '../../../components/BreadCrumbs/BreadCrumbs';
import type { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';

export const PropertyPageBreadCrumbs: FunctionComponent = () => {
  const propertyPage = usePropertyPageQuery()?.data?.propertyPageBySlugV3;
  if (!propertyPage?.breadCrumbs) return null;

  return <BreadCrumbsBar crumbs={propertyPage.breadCrumbs} />;
};
